import { useState, useEffect, useContext } from 'react';

import { ExperienceContext } from '@thd-nucleus/experience-context';

import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { getCurrentInventory } from '../utils/api';
import { formatStoreWithAvailability } from '../utils/helpers';

export const useRentalInventoryApi = ({
  rentalCategory,
  rentalSubCategory,
  storeList,
  graphQlEnabled = false
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const ctx = useContext(ExperienceContext);
  const { hosts } = ctx;
  const { apionline: host } = hosts || {};

  let variables = {
    storeList: [],
    categoryCode: rentalCategory,
    subCategoryCode: rentalSubCategory
  };

  const [getRentalOnHands, _data] = useLazyDataModel('getRentalOnHands', {
    variables,
    ssr: !graphQlEnabled || storeList?.length <= 0 || !rentalCategory || !rentalSubCategory,
  });

  const fetchData = async () => {
    setLoading(true);
    setError('');

    let onHandsResponse = null;
    try {
      if (graphQlEnabled) {
        variables.storeList = storeList.map((store) => store.storeId);
        const { data: graphQlData, error: graphQlError } = await getRentalOnHands({ variables });

        if (graphQlError) {
          throw new Error(graphQlError);
        }

        onHandsResponse = graphQlData?.getRentalOnHands;

      } else {

        const inventoryResponse = await getCurrentInventory({
          host,
          rentalCategory,
          rentalSubCategory,
          storeList
        });

        onHandsResponse = inventoryResponse;
      }

      setData(formatStoreWithAvailability({
        storeList,
        inventory: onHandsResponse || []
      }));
    } catch (err) {
      setError(err.message || 'Unexpected Error');
      setData([]);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    let mounted = true;
    if (rentalCategory && rentalSubCategory && storeList?.length >= 1) {
      fetchData(mounted);
    }
    return () => { mounted = false; };
  }, [rentalCategory, rentalSubCategory, storeList, graphQlEnabled]);

  return { data, loading, error };
};
